module.exports = __webpack_public_path__ + "static/img/WeChat_logo_icon 1.5381ce3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WeChat_logo_icon 1.svg
// module id = X8T1
// module chunks = 1